<div class="exception-body notfound">
    <img [src]="themeService.selectedTheme?.PrimaryShortLogo" alt="logo" class="logo">

    <div class="exception-content">
        <div class="exception-title">{{'Notfound' | translate | uppercase}}</div>
        <div class="exception-detail">{{'RequestedResourceIsNotAvailable' | translate }}</div>
        <a [routerLink]="['/']">{{'GoToDashboard' | translate}}</a>
    </div>
</div>
